/**
 * GET /api/v1/me/waiting — everything waiting on the signed-in person
 * (ADR-0070): release validation gates, signatures, reviews and QA
 * acceptances; tests assigned to them; pipeline approvals they may decide;
 * for Administrators, support tickets and Veeva user changes to approve. The
 * server decides what the person may see; the SPA only words and links it.
 *
 * Types come from the OpenAPI-generated schema in `_generated/schema.d.ts`.
 */

import type { components } from "./_generated/schema";
import { apiFetch } from "./apiFetch";

export type WaitingItem = components["schemas"]["WaitingItemOut"];
export type WaitingOut = components["schemas"]["WaitingOut"];

/** Polled with the bell and the Home page: pass `background` so polling does
 *  not count as activity for the idle sign-out (ADR-0046). */
export function getWaiting(
  token: string,
  opts: { background?: boolean } = {},
): Promise<WaitingOut> {
  return apiFetch<WaitingOut>("/api/v1/me/waiting", { token, background: opts.background });
}
